import script from "./leaseItemDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./leaseItemDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./leaseItemDetailPage.vue?vue&type=style&index=0&id=6ccf5708&lang=scss&scoped=true"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ccf5708"]])

export default __exports__